import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { signInSchema } from "../schemas/schemas";
import { useSignInMutation } from '../api/mutations/signIn.mutation';
import { Link } from "react-router-dom";
import { Logo } from "../assets/imageAssets";
import Input from "../components/Input";
import Button from "../components/Button";
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        shouldUseNativeValidation: false,
        resolver: yupResolver(signInSchema),
    });
    const { isLoading, mutate } = useSignInMutation();

    return (
        <div className="login">
            <div className="login__content flex flex-align-center flex-direction-col text-center">
                <div className="logo">
                    <img src={Logo} alt="Logo" />
                </div>
                <div>
                    <h1 className='mb-12'>Log in to your account</h1>
                    <p className='text-min text-color-grey'>Welcome back! Please enter your details.</p>
                </div>
                <form className='full-width' onSubmit={handleSubmit(mutate)}>
                    <Input
                        label='Email'
                        placeholder='Enter your email'
                        id='email'
                        className={'mb-20'}
                        register={{ ...register('email') }}
                        error={errors?.email}
                        errorMessage={errors?.email?.message}
                    />
                    <Input
                        label='Password'
                        placeholder='Enter you password'
                        id='password'
                        type='password'
                        className={'mb-20'}
                        register={{ ...register('password') }}
                        error={errors?.password}
                        errorMessage={errors?.password?.message}
                    />
                    <div className='mb-24 text-color-grey-dark'>
                        Need an account? <Link to={'/registration'} className='text-underline'>Sign up</Link>
                    </div>
                    <Button 
                        text='Sign in' 
                        className={'full-width mb-16'}
                    />
                    <GoogleLogin
                        theme="outline"
                        text="signin_with"
                        shape="rectangular"
                        onSuccess={(credentialResponse) => {
                            // const decoded = jwt_decode(credentialResponse.credential);
                            console.log('User Info:', credentialResponse); // name, email, picture, etc.
                        }}
                        onError={() => {
                            console.log('Login Failed');
                        }}
                    />
                </form>
            </div>
        </div>
    );
}

export default Login;